<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/c26/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/c26/title-1.png" alt="" />
                    <div class="content">
                        在成都创业就业的新市民、青年人等群体。
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/c26/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="dot">1</div>
                                年满十八周岁且具有完全民事行为能力；
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                在拟租住的保障性租赁住房所在区（市）县无自有住房；
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                在成都未享受其他方式住房保障。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/c26/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）符合条件的人才，可以登录“成都市保障性租赁住房管理服务平台”选择意向房源租赁，租金标准为不超过市场租金标准的90%。
                            <!-- <div style="color: #0839b7; font-weight: 500">
                                            注：具体租金标准按照市房屋租赁服务中心定期发布的《成都市租赁住房平均租金水平信息》执行。
                                        </div> -->
                        </div>
                        <div class="des">
                            （二）符合我市人才安居政策并承租产业功能区配套住房的人才，按照原则上不低于市场租金的25%给予租金补贴。
                            <div style="color: #0839b7; font-weight: 500">
                                注：补贴标准由区（市）县政府（管委会）确定
                            </div>
                        </div>
                    </div>
                </div>

                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/25/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">
                                        申请“保障性租赁住房天府租赁码”
                                    </div>
                                </div>
                                <div class="line-content">
                                    人才可自行登录“住建蓉e办”（成都市住房和城乡建设局网上政务大厅），进入保障性租赁住房服务平台,按照提示填报个人信息，申请取得“保障性租赁住房天府租赁码”。
                                    <div style="color: #0839b7; font-weight: 500">
                                        https://zw.cdzjryb.com/publicCAS/citizenPerson/login
                                    </div>
                                    <div>
                                        （为提升操作便利，建议使用电脑浏览器打开）
                                    </div>
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">
                                        关注项目登记公告参与登记
                                    </div>
                                </div>
                                <div class="line-content">
                                    取得租赁码后，再次进入保障性租赁住房服务平台，在“项目公告”专栏关注意向项目，并按照提示进行登记报名。登记时间的先后顺序将作为选房顺序，选房顺序将在项目选房公告中公示。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61881352">028-61881352</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市住房和城乡建设局住房保障处
                        </div>
                        <!-- <div>
                                      政策咨询电话：
                                      <a href="tel:028-86259119">028-86259119</a>
                                  </div>
                                  <div>责任单位：中共成都市青羊区委组织部人才科</div> -->
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/c26/code.png" />
                    <img class="text" src="../assets/imgs/c26/text.png" />
                </div>
                <div class="part">
                    <img src="../assets/imgs/c26/part.png" style="width: 100%; height: 100%" />
                    <div class="call">
                        <div class="item">
                            <a href="tel:028-68773090" class="inside"></a>
                            <a href="tel:028-68773091" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-86360037" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-85327961" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-84531499" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-87701527" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-87612978" class="inside"></a>
                            <a href="tel:028-87537869" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-85440059" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-84399067" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-84857075" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-83668168" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-89396620" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-82727193" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-85801811" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-87862150" class="inside"></a>
                        </div>
                         <div class="item">
                            <a href="tel:028-82518637" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-27228483" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-87112052" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-83707181" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-88772065" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-82180719" class="inside"></a>
                        </div>
                         <div class="item">
                            <a href="tel:028-84935006" class="inside"></a>
                        </div>
                        <div class="item">
                            <a href="tel:028-88290117" class="inside"></a>
                        </div>
                       <div class="item">
                            <a href="tel:028-88530600" class="inside"></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <call phone="028-61881352"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.3rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                // font-family: PingFang SC-Bold, PingFang SC;
                text-align: left;
                color: #333333;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                line-height: 0.44rem;

                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                    line-height: 0.44rem;

                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                margin-top: -0.74rem;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;
                    line-height: 0.44rem;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            left: 0.6rem;
                            position: absolute;
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }

        .part {
            display: block;
            width: 6.85rem;
            height: 14.93rem;
            margin: 0.22rem auto;
            margin-bottom: 0;
            position: relative;

            .call {
                height: 12.2rem;
                width: 63%;
                // background: red;
                position: absolute;
                opacity: 0.5;
                right: 0;
                top: 17.2%;
                display: flex;
                flex-direction: column;

                .item {
                    flex: 1;
                    // background-color: #333333;
                    display: flex;

                    .inside {
                        flex: 1;
                        // background-color: #3d5aa3;
                    }
                }
            }
        }
    }
}
</style>
